export default __webpack_public_path__ + "static/media/iGnite.00b26df3.jpg";